
// Angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../core/reducers';

// NGRX
// State
import { AccountService } from '../../../../../../app/modules';
import { Observable } from 'rxjs';
import { currentUser, User } from '../../../../../core/auth';
@Component({
  selector: 'wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class WalletComponent implements OnInit {
  user$: Observable<User>;
  constructor(private changeDetectorRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private accountService: AccountService) {
  }

  ngOnInit() {
    this.user$ = this.store.pipe(select(currentUser));
  }



}
